import { getExactKeyPath, setKeyPath } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import { useCallback, useContext } from 'react';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import { useEditorActions } from './useEditorActions';
export const useNullAssociationState = conditionPath => {
  const {
    internalDraftValue
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    onChangeInternal
  } = useEditorActions();
  const onCheckboxChange = useCallback(evt => {
    const filterGroup = getExactKeyPath(conditionPath, internalDraftValue).set('includeObjectsWithNoAssociatedObjects', evt.target.checked);
    const newInternalDraftValue = setKeyPath(conditionPath, filterGroup, internalDraftValue);
    onChangeInternal(newInternalDraftValue);
  }, [conditionPath, internalDraftValue, onChangeInternal]);
  return {
    onCheckboxChange
  };
};